import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=453cfb29"
import script from "./paymentPage.vue?vue&type=script&lang=js"
export * from "./paymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports